import React, { useState, useEffect } from "react";
import axios from "axios";
import { Modal } from "react-bootstrap";
import { BASE_URL } from "../../config/axios";
import { ToastContainer, toast } from "react-toastify";
import { formattedDateLong, formattedDateNoYear } from "../Date";
import { AddwithBlueCircle, AddwithWhiteCircle, DeleteDustbin, DropdownArrowOption, UpdatePencil } from "../AllSvg";
import { customSortByKey, FormatKey, handleAllError, handleErrorToast } from "../CustomFunctions";
import usePermission from "../../config/permissions";

const AddStationaryItem = ({ getItemsList }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [formData, setFormData] = useState({
        item_name: "",
        sub_company: sessionStorage.getItem('company_id')
    });

    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["item_name"];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);
        setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };

    // ?  ************** Validation End **************  ! //
    const [loading, setLoading] = useState(false); //loading logic

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {
                let res = await axios.post(
                    `${BASE_URL}/wfm/stationary/`,
                    formData,
                );

                if (res.status === 200) {
                    await getItemsList();
                    setShow(false)
                } else {
                    alert(res);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId)
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };

    return (
        <>
            <button
                title="Add Item"
                className="upload-svg"
                onClick={handleShow}
            >
                <AddwithWhiteCircle /> Add Item
            </button>
            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <h6 className="task-Tab-heading   font-weight500    font-size-heading">Add Item</h6>

                            <form>
                                <div className="flex-column">
                                    <label htmlFor="item_name" className="form-labels  font-weight500    announce-date font-weight400  font-size-heading">
                                        Name
                                    </label>
                                    <input
                                        id="item_name"
                                        type="item_name"
                                        name="item_name"
                                        maxLength={50}
                                        placeholder="Item Name"
                                        onChange={handleInputChange}
                                        value={formData.name}
                                        className={`form-input ${errors.item_name ? "error" : inputState.item_name ? "success" : ""
                                            }`}
                                    />
                                    {errors.item_name && (
                                        <span className="error-message font-size-text ">{FormatKey(errors.item_name)}</span>
                                    )}
                                </div>

                            </form>
                            <div className="button-models">
                                <button className="model-button model-button-cancel font-weight500" onClick={handleClose}>
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                                    onClick={handleSubmit}
                                    disabled={loading}
                                >
                                    Add
                                </button>
                            </div>
                        </div>

                        <p className="error-message font-size-text">
                            {isSubmitted && Object.keys(errors).length > 0 && (
                                Object.keys(errors).length > 5 ? (
                                    <h5 className="text-center">Please fill all mandatory fields!</h5>
                                ) : (
                                    <h6 className="text-center">
                                        {Object.keys(errors)
                                            .map((field) =>
                                                field
                                                    .replace(/_/g, ' ')
                                                    .replace(/\b\w/g, (char) => char.toUpperCase())
                                            )
                                            .join(', ') + ' are required!'}
                                    </h6>
                                )
                            )}
                        </p>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    );
};

const UpdateStationaryItem = ({ i, getItemsList }) => {
    const [show, setShow] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => {
        setFormData(i)
        setShow(true)
    };

    const [formData, setFormData] = useState({
        item_name: "",
    });


    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["item_name"];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });
        setIsSubmitted(true);
        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    // ?  ************** Validation End **************  ! //

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {
                let res = await axios.put(
                    `${BASE_URL}/wfm/stationary/${i.id}/`,
                    formData,

                );

                if (res.status === 200) {
                    await getItemsList();
                    setShow(false)
                } else {
                    alert(res);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId)
            } finally {
                toast.dismiss(loadingToastId);
            }
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };

    return (
        <>
            <button title="Update Item" className="model-edit-button-ml" onClick={handleShow}>
                <UpdatePencil />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <h6 className="task-Tab-heading   font-weight500    font-size-heading">Update Item</h6>

                            <form>
                                <div className="flex-column">
                                    <label htmlFor="item_name" className="form-labels  font-weight500    announce-date font-weight400  font-size-heading">
                                        Name
                                    </label>
                                    <input
                                        id="item_name"
                                        type="item_name"
                                        name="item_name"
                                        placeholder="Item Name"
                                        onChange={handleInputChange}
                                        value={formData.item_name}
                                        className={`form-input ${errors.item_name ? "error" : inputState.item_name ? "success" : ""
                                            }`}
                                    />
                                    {errors.item_name && (
                                        <span className="error-message font-size-text ">{FormatKey(errors.item_name)}</span>
                                    )}
                                </div>
                            </form>
                            <div className="button-models">
                                <button className="model-button model-button-cancel font-weight500"
                                    onClick={handleClose}>
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                                    onClick={handleSubmit}
                                >
                                    Update
                                </button>
                            </div>
                        </div>
                        <p className="error-message font-size-text">
                            {isSubmitted && Object.keys(errors).length > 0 && (
                                Object.keys(errors).length > 5 ? (
                                    <h5 className="text-center">Please fill all mandatory fields!</h5>
                                ) : (
                                    <h6 className="text-center">
                                        {Object.keys(errors)
                                            .map((field) =>
                                                field
                                                    .replace(/_/g, ' ')
                                                    .replace(/\b\w/g, (char) => char.toUpperCase())
                                            )
                                            .join(', ') + ' are required!'}
                                    </h6>
                                )
                            )}
                        </p>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    );
};

const DeleteStationaryItem = ({ i, getItemsList }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
        try {
            let res = await axios.delete(
                `${BASE_URL}/wfm/stationary/${i.id}/`
            );

            if (res.status === 200) {
                await getItemsList();
                setShow(false);
            } else {
                alert(res);
            }
        } catch (err) {

            handleErrorToast(err, loadingToastId)
        } finally {
            toast.dismiss(loadingToastId);
        }
    };
    return (
        <>
            <button title="Delete Item" className="model-delete-button" onClick={handleShow}>
                <DeleteDustbin />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Header closeButton>
                    <Modal.Title>Delete Item {i.name}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are You Sure You Want to Delete Item {i.name}
                        <div className="button-models">
                            <button className="model-button   font-weight500    " onClick={handleClose}>
                                Cancel
                            </button>
                            <button
                                onClick={handleFormSubmitDelete}
                                className="model-button   font-weight500    model-button-delete"
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    );
};


const AddItemToStock = ({ getStockList, itemList }) => {
    const [show, setShow] = useState(false);
    const [buffer, setBuffering] = useState(true); //buffering logic
    const [isSubmitted, setIsSubmitted] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true)
    };
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1;
    const day = today.getDate();
    const formattedDate = `${year}-${month.toString().padStart(2, "0")}-${day
        .toString()
        .padStart(2, "0")}`;

    const [formData, setFormData] = useState({
        item_id: "",
        quantity: 0,
        vendor_name: "",
        purchase_date: formattedDate,
        rate_per_item: 0,
    });

    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["item_id", "quantity", "vendor_name", "rate_per_item"];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);
        setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };

    // ?  ************** Validation End **************  ! //
    const [loading, setLoading] = useState(false); //loading logic

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {
                let res = await axios.post(
                    `${BASE_URL}/wfm/stationary-inventory-details/`, formData,);

                if (res.status === 200) {
                    await getStockList();
                    setShow(false)
                } else {
                    alert(res);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId)
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };


    return (
        <>

            <button
                title="Add Stock Item"
                className="upload-svg"
                onClick={handleShow}
            >
                <AddwithWhiteCircle /> Add Stock Item
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <h6 className="task-Tab-heading   font-weight500    font-size-heading">Stock Item</h6>

                            <form>

                                <div className="flex-column form-group-selectt">
                                    <label htmlFor="item_id" className="form-labels  font-weight500    font-size-subheading">
                                        Item<span className="required">*</span>
                                    </label>
                                    <br />
                                    <select
                                        id="item_id"
                                        name="item_id"
                                        value={formData.item_id}
                                        onChange={handleInputChange}
                                        className={`form-input form-group-selection ${errors.item_id ? "error" : inputState.item_id ? "success" : ""
                                            }`}
                                    >
                                        <option value="">Select Item</option>
                                        {itemList.map((i) => (<>
                                            <option value={i.id}>{i.item_name}</option>
                                        </>))
                                        }
                                    </select>
                                    <div className="form-group-selection-arrow">
                                        <DropdownArrowOption />
                                    </div>
                                    <div>
                                        {errors.item_id && (
                                            <span className="error-message font-size-text ">{FormatKey(errors.item_id)}</span>
                                        )}
                                    </div>
                                </div>
                                <div className="flex-column">
                                    <label htmlFor="quantity" className="form-labels  font-weight500    font-size-subheading">
                                        Quantity<span className="required">*</span>
                                    </label>
                                    <input
                                        type="number"
                                        min={0}
                                        id="quantity"
                                        name="quantity"
                                        onChange={handleInputChange}
                                        value={formData.quantity}
                                        className={`text-capitalize form-input ${errors.quantity ? "error" : inputState.quantity ? "success" : ""
                                            }`}
                                    />
                                    {errors.quantity && <span className="error-message font-size-text ">{FormatKey(errors.quantity)}</span>}
                                </div>

                                <div className="flex-column">
                                    <label htmlFor="vendor_name" className="form-labels  font-weight500    font-size-subheading">
                                        Vendor<span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="vendor_name"
                                        name="vendor_name"
                                        onChange={handleInputChange}
                                        value={formData.vendor_name}
                                        className={`form-input ${errors.vendor_name ? "error" : inputState.vendor_name ? "success" : ""
                                            }`}
                                    />
                                    {errors.vendor_name && <span className="error-message font-size-text ">{FormatKey(errors.vendor_name)}</span>}
                                </div>

                                <div className="flex-column">
                                    <label htmlFor="rate_per_item" className="form-labels  font-weight500    font-size-subheading">
                                        Rate Per Item<span className="required">*</span>
                                    </label>
                                    <input
                                        type="number"
                                        min={0}
                                        id="rate_per_item"
                                        name="rate_per_item"
                                        onChange={handleInputChange}
                                        value={formData.rate_per_item}
                                        className={`text-capitalize form-input ${errors.rate_per_item ? "error" : inputState.rate_per_item ? "success" : ""
                                            }`}
                                    />
                                    {errors.rate_per_item && <span className="error-message font-size-text ">{FormatKey(errors.rate_per_item)}</span>}
                                </div>

                                <div className="flex-column">
                                    <label htmlFor="purchase_date" className="form-labels  font-weight500    font-size-subheading">
                                        Purchase Date<span className="required">*</span>
                                    </label>
                                    <input
                                        type="date"
                                        id="purchase_date"
                                        name="purchase_date"
                                        onChange={handleInputChange}
                                        value={formData.purchase_date}
                                        className={`form-input ${errors.purchase_date ? "error" : inputState.purchase_date ? "success" : ""
                                            }`}
                                    />
                                    {errors.purchase_date && <span className="error-message font-size-text ">{FormatKey(errors.purchase_date)}</span>}
                                </div>

                            </form>

                            <div className="button-models">
                                <button className="model-button model-button-cancel font-weight500" onClick={handleClose}>
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                                    onClick={handleSubmit}
                                    disabled={loading}
                                >
                                    Add
                                </button>
                            </div>
                        </div>
                        <p className="error-message font-size-text">
                            {isSubmitted && Object.keys(errors).length > 0 && (
                                Object.keys(errors).length > 5 ? (
                                    <h5 className="text-center">Please fill all mandatory fields!</h5>
                                ) : (
                                    <h6 className="text-center">
                                        {Object.keys(errors)
                                            .map((field) =>
                                                field
                                                    .replace(/_/g, ' ')
                                                    .replace(/\b\w/g, (char) => char.toUpperCase())
                                            )
                                            .join(', ') + ' are required!'}
                                    </h6>
                                )
                            )}
                        </p>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    );
};

const UpdateItemInStock = ({ i, getStockList }) => {
    const [show, setShow] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => {
        setFormData(i);
        setShow(true)
    };


    const [formData, setFormData] = useState({
        item_id: "",
        quantity: 0,
        vendor_name: "",
        purchase_date: "",
        rate_per_item: 0,
    });

    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["item_id", "quantity", "vendor_name", "rate_per_item", "purchase_date"];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);
        setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };

    // ?  ************** Validation End **************  ! //

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {
                let res = await axios.put(
                    `${BASE_URL}/wfm/stationary-inventory-details/${i.id}/`,
                    formData,
                );

                if (res.status === 200) {
                    await getStockList();
                    setShow(false)
                } else {
                    alert(res);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId)

            } finally {
                toast.dismiss(loadingToastId);
            }
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };


    return (
        <>
            <button title="Update Stock Item" className="model-edit-button-ml" onClick={handleShow}>
                <UpdatePencil />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <h6 className="task-Tab-heading   font-weight500    font-size-heading">Update : {i.item_name}</h6>

                            <form>


                                {/* <div className="flex-column">
                                        <label htmlFor="quantity" className="form-labels  font-weight500   ">
                                            Quantity<span className="required">*</span>
                                        </label>
                                        <input
                                            type="number"
                                            min={0}
                                            id="quantity"
                                            name="quantity"
                                            onChange={handleInputChange}
                                            value={formData.quantity}
                                            className={`text-capitalize form-input ${errors.quantity ? "error" : inputState.quantity ? "success" : ""
                                                }`}
                                        />
                                        {errors.quantity && <span className="error-message">{errors.quantity}</span>}
                                    </div> */}

                                <div className="flex-column">
                                    <label htmlFor="vendor_name" className="form-labels  font-weight500    font-size-subheading">
                                        Vendor<span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="vendor_name"
                                        name="vendor_name"
                                        onChange={handleInputChange}
                                        value={formData.vendor_name}
                                        className={`form-input ${errors.vendor_name ? "error" : inputState.vendor_name ? "success" : ""
                                            }`}
                                    />
                                    {errors.vendor_name && <span className="error-message font-size-text ">{FormatKey(errors.vendor_name)}</span>}
                                </div>

                                <div className="flex-column">
                                    <label htmlFor="rate_per_item" className="form-labels  font-weight500    font-size-subheading">
                                        Rate Per Item<span className="required">*</span>
                                    </label>
                                    <input
                                        type="number"
                                        min={0}
                                        id="rate_per_item"
                                        name="rate_per_item"
                                        onChange={handleInputChange}
                                        value={formData.rate_per_item}
                                        className={`text-capitalize form-input ${errors.rate_per_item ? "error" : inputState.rate_per_item ? "success" : ""
                                            }`}
                                    />
                                    {errors.rate_per_item && <span className="error-message font-size-text ">{FormatKey(errors.rate_per_item)}</span>}
                                </div>

                                <div className="flex-column">
                                    <label htmlFor="purchase_date" className="form-labels  font-weight500    font-size-subheading">
                                        Purchase Date<span className="required">*</span>
                                    </label>
                                    <input
                                        type="date"
                                        id="purchase_date"
                                        name="purchase_date"
                                        onChange={handleInputChange}
                                        value={formData.purchase_date}
                                        className={`form-input ${errors.purchase_date ? "error" : inputState.purchase_date ? "success" : ""
                                            }`}
                                    />
                                    {errors.purchase_date && <span className="error-message font-size-text ">{FormatKey(errors.purchase_date)}</span>}
                                </div>


                            </form>
                            <div className="button-models">
                                <button className="model-button model-button-cancel font-weight500" onClick={handleClose}>
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                                    onClick={handleSubmit}
                                >
                                    Add
                                </button>
                            </div>
                        </div>
                        <p className="error-message font-size-text">
                            {isSubmitted && Object.keys(errors).length > 0 && (
                                Object.keys(errors).length > 5 ? (
                                    <h5 className="text-center">Please fill all mandatory fields!</h5>
                                ) : (
                                    <h6 className="text-center">
                                        {Object.keys(errors)
                                            .map((field) =>
                                                field
                                                    .replace(/_/g, ' ')
                                                    .replace(/\b\w/g, (char) => char.toUpperCase())
                                            )
                                            .join(', ') + ' are required!'}
                                    </h6>
                                )
                            )}
                        </p>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    );
};

const DeleteItemFromStock = ({ i, getStockList }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
        try {
            let res = await axios.delete(
                `${BASE_URL}/wfm/stationary-inventory-details/${i.id}/`
            );

            if (res.status === 200) {
                await getStockList();
                setShow(false);
            } else {
                alert(res);
            }
        } catch (err) {

            handleErrorToast(err, loadingToastId)
        } finally {
            toast.dismiss(loadingToastId);
        }
    };
    return (
        <>
            <button title="Delete Stock Item" className="model-delete-button" onClick={handleShow}>
                <DeleteDustbin />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Header closeButton>
                    <Modal.Title>Delete {i.item_name}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are You Sure You Want to delete {i.item_name} from Inventory
                        <div className="button-models">
                            <button className="model-button   font-weight500    " onClick={handleClose}>
                                Cancel
                            </button>
                            <button
                                onClick={handleFormSubmitDelete}
                                className="model-button   font-weight500    model-button-delete"
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    );
};



const GiveEmployeeStationary = ({ getEmployeeItemsList, getStockList, stockItemList }) => {
    const [show, setShow] = useState(false);
    const { SUB_COMPANIES, PERMISSION_AUTHORITY } = usePermission();
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [selectedEmployee, setSelectedEmployee] = useState("Internal Employee");
    const handleClose = () => setShow(false);
    const handleShow = () => {
        getAllEmp_code(toggleCompany)
        getStockList()
        setShow(true)
    };

    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1;
    const day = today.getDate();
    const formattedDate = `${year}-${month.toString().padStart(2, "0")}-${day
        .toString()
        .padStart(2, "0")}`;

    const [formData, setFormData] = useState({
        stat_inventory_details: "",
        employee: "",
        quantity: 0,
        recevied_date: formattedDate,
        external_person_name: "",
        external_contact: "",
        external_mail: "",
        external_reason: "",
    });
    const [availableStock, setAvailableStock] = useState(0);

    const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem("company_id"));

    const [empList, setEmpList] = useState([])
    const [buffer, setBuffering] = useState(true); //buffering logic
    const getAllEmp_code = async (toggleCompany) => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(
                `${BASE_URL}/wfm/ourcompanyempdetailsactive/${toggleCompany}/`
            );

            const sortedList = customSortByKey(res.data, "emp_code");

            setEmpList(sortedList);
        } catch (err) {
            //toast Logic
            handleAllError(err)
        } finally {
            setBuffering(false);// End Buffering
        }
    };

    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const InternalEmpReqField = ["stat_inventory_details", "employee", "quantity", "recevied_date"];
        const ExternalEmpReqField = ["stat_inventory_details", "quantity", "recevied_date", "external_person_name", "external_contact", "external_mail", "external_reason"];
        let requiredFields;
        selectedEmployee === "Internal Employee"
            ? requiredFields = InternalEmpReqField
            : requiredFields = ExternalEmpReqField

        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);
        setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };

    // ?  ************** Validation End **************  ! //
    const [loading, setLoading] = useState(false); //loading logic

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            const loadingToastId = toast.loading("Loading: Please wait...");
            let payload = {
                stat_inventory_details: formData.stat_inventory_details,
                quantity: formData.quantity,
                recevied_date: formData.recevied_date,
            };
            if (selectedEmployee === "Internal Employee") {
                payload.employee = formData.employee;
            } else {
                payload.external_person_name = formData.external_person_name;
                payload.external_contact = formData.external_contact;
                payload.external_mail = formData.external_mail;
                payload.external_reason = formData.external_reason;
            }
            try {

                let res = await axios.post(
                    `${BASE_URL}/wfm/stationary-employee-details/`,
                    payload,
                );

                if (res.status === 200) {
                    await getStockList();
                    await getEmployeeItemsList();

                    setShow(false)
                    toast.success("Items Added to Employee successfully!");
                }
            } catch (err) {
                handleAllError(err, loadingToastId)
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });


        if (name === "stat_inventory_details") {
            const selectedItem = stockItemList.find(item => item.id === value);
            if (selectedItem) {
                setAvailableStock(selectedItem.quantity - selectedItem.distributed_quantity);
            } else {
                setAvailableStock(0);
            }
        }

        if (value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
    };

    const handleSubCompanyChange = (e) => {
        const { value } = e.target;
        setToggleCompany(value)
        getAllEmp_code(value)

    };



    return (
        <>

            <button
                title="Issue Items to Employee"
                className="upload-svg"
                onClick={handleShow}
            >
                <AddwithWhiteCircle /> Add Items to Employee
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">

                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <h6 className="task-Tab-heading   font-weight500    font-size-heading">Issue Item to Employee</h6>
                            <div className="margin-top-10px">
                                <div className="leave-duration-tabs" style={{ width: "96%", position: "relative", display: "flex", marginBottom: "15px" }}>
                                    <input
                                        type="radio"
                                        id="internal-employee"
                                        name="internal_employee"
                                        value="Internal Employee"
                                        checked={selectedEmployee === "Internal Employee"}
                                        onChange={(e) => setSelectedEmployee(e.target.value)}
                                        hidden
                                    />
                                    <label htmlFor="internal-employee" className="leave-tab" style={{ flex: 1, textAlign: "center" }}>
                                        Internal Employee
                                    </label>

                                    <input
                                        type="radio"
                                        id="external-employee"
                                        name="external_employee"
                                        value="External Employee"
                                        checked={selectedEmployee === "External Employee"}

                                        onChange={(e) => setSelectedEmployee(e.target.value)}
                                        hidden
                                    />
                                    <label htmlFor="external-employee" className="leave-tab" style={{ flex: 1, textAlign: "center" }}>
                                        External Employee
                                    </label>

                                    <span
                                        className="leave-tab-glider"
                                        style={{
                                            transform: selectedEmployee === "Internal Employee" ? "translateX(0%)" : "translateX(100%)",
                                            width: "50%"
                                        }}
                                    ></span>
                                </div>
                            </div>

                            {PERMISSION_AUTHORITY ?
                                <div className="flex-column form-group-selectt">
                                    <label htmlFor="sub_company" className="form-labels  font-weight500    font-size-subheading">
                                        Sub Company<span className="required">*</span>
                                    </label>
                                    <br />
                                    <select
                                        id="sub_company"
                                        name="sub_company"
                                        value={toggleCompany}
                                        onChange={handleSubCompanyChange}
                                        className={`form-input form-group-selection ${errors.sub_company ? "error" : inputState.sub_company ? "success" : ""
                                            }`}
                                    >
                                        {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};
                                    </select>
                                    <div className="form-group-selection-arrow">
                                        <DropdownArrowOption />
                                    </div>
                                </div>
                                : null}

                            <div className="flex-column form-group-selectt">
                                <label htmlFor="stat_inventory_details" className="form-labels  font-weight500    font-size-subheading">
                                    Item<span className="required">*</span>
                                </label>
                                <br />
                                <select
                                    id="stat_inventory_details"
                                    name="stat_inventory_details"
                                    value={formData.stat_inventory_details}
                                    onChange={handleInputChange}
                                    className={`form-input form-group-selection ${errors.stat_inventory_details ? "error" : inputState.stat_inventory_details ? "success" : ""
                                        }`}
                                >
                                    <option value="">Select Item</option>
                                    {stockItemList.map((i) => (<>
                                        {(i.quantity - i.distributed_quantity) > 0 ?
                                            <option value={i.id}>{i.item_name}  |  Stock: {formattedDateNoYear(i.purchase_date)},  items left: {i.quantity - i.distributed_quantity}</option>
                                            : null
                                        }
                                    </>))
                                    }
                                </select>
                                <div className="form-group-selection-arrow">
                                    <DropdownArrowOption />
                                </div>
                                <div>
                                    {errors.stat_inventory_details && (
                                        <span className="error-message font-size-text ">{FormatKey(errors.stat_inventory_details)}</span>
                                    )}
                                </div>
                            </div>

                            <div className="flex-column">
                                <label htmlFor="quantity" className="form-labels  font-weight500    font-size-subheading">
                                    Quantity<span className="required">*</span>
                                </label>
                                <input
                                    type="number"
                                    min={0}
                                    id="quantity"
                                    max={availableStock} // Set max limit
                                    name="quantity"
                                    onChange={handleInputChange}
                                    value={formData.quantity}
                                    className={`text-capitalize form-input ${errors.quantity ? "error" : inputState.quantity ? "success" : ""
                                        }`}
                                />
                                {errors.quantity && <span className="error-message font-size-text ">{FormatKey(errors.quantity)}</span>}
                            </div>
                            <div className="flex-column">
                                <label htmlFor="recevied_date" className="form-labels  font-weight500    font-size-subheading">
                                    Issue Date<span className="required">*</span>
                                </label>
                                <input
                                    type="date"
                                    id="recevied_date"
                                    name="recevied_date"
                                    onChange={handleInputChange}
                                    value={formData.recevied_date}
                                    className={`form-input ${errors.recevied_date ? "error" : inputState.recevied_date ? "success" : ""
                                        }`}
                                />
                                {errors.recevied_date && <span className="error-message font-size-text ">{FormatKey(errors.recevied_date)}</span>}
                            </div>

                            {selectedEmployee === "Internal Employee" ?
                                (
                                    <form>



                                        <div className="flex-column form-group-selectt">
                                            <label htmlFor="employee" className="form-labels  font-weight500    font-size-subheading">
                                                Employee<span className="required">*</span>
                                            </label>
                                            <br />
                                            {buffer ?
                                                <div className="form-loader">
                                                    <div className="bar-loader"></div>
                                                </div>
                                                :
                                                <>
                                                    <select
                                                        id="employee"
                                                        name="employee"
                                                        value={formData.employee}
                                                        onChange={handleInputChange}
                                                        className={`form-input form-group-selection ${errors.employee ? "error" : inputState.employee ? "success" : ""
                                                            }`}
                                                    >
                                                        <option value="">Select Employee</option>
                                                        {empList.map((i) => (<>
                                                            <option value={i.emp_code}>{i.emp_code}-{i.name}</option>
                                                        </>))
                                                        }
                                                    </select>
                                                    <div className="form-group-selection-arrow">
                                                        <DropdownArrowOption />
                                                    </div>
                                                    <div>
                                                        {errors.employee && (
                                                            <span className="error-message font-size-text ">{FormatKey(errors.employee)}</span>
                                                        )}
                                                    </div>
                                                </>}
                                        </div>





                                    </form>
                                )
                                : (
                                    <>

                                        <div className="flex-column">
                                            <label htmlFor="external_person_name" className="form-labels font-weight500 font-size-subheading">
                                                Name:<span className="required">*</span>
                                            </label>
                                            <input
                                                id="external_person_name"
                                                type="text"
                                                name="external_person_name"
                                                maxLength={150}
                                                placeholder="Name"
                                                onChange={handleInputChange}
                                                value={formData.external_person_name}
                                                className={`form-input ${errors.external_person_name ? "error" : inputState.external_person_name ? "success" : ""
                                                    }`}
                                            />
                                            {errors.external_person_name && (
                                                <span className="error-message font-size-text ">{FormatKey(errors.external_person_name)}</span>
                                            )}
                                        </div>
                                        <div className="flex-column">
                                            <label htmlFor="external_contact" className="form-labels font-weight500 font-size-subheading">
                                                Contact:<span className="required">*</span>
                                            </label>
                                            <input
                                                id="external_contact"
                                                type="text"
                                                name="external_contact"
                                                placeholder="Contact No"
                                                onChange={handleInputChange}
                                                value={formData.external_contact}
                                                className={`form-input ${errors.external_contact ? "error" : inputState.external_contact ? "success" : ""
                                                    }`}
                                            />
                                            {errors.external_contact && (
                                                <span className="error-message font-size-text ">{FormatKey(errors.external_contact)}</span>
                                            )}
                                        </div>
                                        <div className="flex-column">
                                            <label htmlFor="external_mail" className="form-labels font-weight500 font-size-subheading">
                                                Mail:<span className="required">*</span>
                                            </label>
                                            <input
                                                id="external_mail"
                                                type="text"
                                                name="external_mail"
                                                placeholder="Contact Mail"
                                                onChange={handleInputChange}
                                                value={formData.external_mail}
                                                className={`form-input ${errors.external_mail ? "error" : inputState.external_mail ? "success" : ""
                                                    }`}
                                            />
                                            {errors.external_mail && (
                                                <span className="error-message font-size-text ">{FormatKey(errors.external_mail)}</span>
                                            )}
                                        </div>

                                        <div className="flex-column">
                                            <label className="form-labels font-weight500 font-size-subheading">
                                                Reason:<span className="required">*</span>
                                            </label>
                                            <textarea
                                                name="external_reason"
                                                placeholder="Your reason (minimum 10 characters)"
                                                className="form-input-textarea"
                                                value={formData.external_reason}
                                                onChange={handleInputChange}
                                                rows="3"
                                            />
                                        </div>
                                    </>
                                )}





                            <div className="button-models">
                                <button className="model-button model-button-cancel font-weight500" onClick={handleClose}>
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                                    onClick={handleSubmit}
                                    disabled={loading}
                                >
                                    Add
                                </button>
                            </div>
                        </div>
                        <p className="error-message font-size-text">
                            {isSubmitted && Object.keys(errors).length > 0 && (
                                Object.keys(errors).length > 5 ? (
                                    <h5 className="text-center">Please fill all mandatory fields!</h5>
                                ) : (
                                    <h6 className="text-center">
                                        {Object.keys(errors)
                                            .map((field) =>
                                                field
                                                    .replace(/_/g, ' ')
                                                    .replace(/\b\w/g, (char) => char.toUpperCase())
                                            )
                                            .join(', ') + ' are required!'}
                                    </h6>
                                )
                            )}
                        </p>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    );
};

const UpdateEmployeeStationary = ({ i, getEmployeeItemsList, stockItemList }) => {
    const [show, setShow] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => {
        setFormData(i);
        setShow(true)
    };


    const [formData, setFormData] = useState({
        stat_inventory_details: "",
        employee: "",
        quantity: 0,
        recevied_date: "",
        external_person_name: "",
        external_contact: "",
        external_mail: "",
        external_reason: "",
    });

    useEffect(() => {
        setFormData(i);
    }, [i]);

    // !  ************** Validation start **************  ! //
    const [selectedEmployee, setSelectedEmployee] = useState("")
    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const InternalEmpReqField = ["stat_inventory_details", "employee", "quantity", "recevied_date"];
        const ExternalEmpReqField = ["stat_inventory_details", "quantity", "recevied_date", "external_person_name", "external_contact", "external_mail", "external_reason"];
        let requiredFields;
        i?.employee === null
            ? requiredFields = ExternalEmpReqField
            : requiredFields = InternalEmpReqField

        // const requiredFields = ["stat_inventory_details", "employee", "quantity", "recevied_date"];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);
        setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };

    // ?  ************** Validation End **************  ! //

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
            let payload = {
                stat_inventory_details: formData.stat_inventory_details,
                quantity: formData.quantity,
                recevied_date: formData.recevied_date,
            };
            if (i?.employee === null) {
                payload.external_person_name = formData.external_person_name;
                payload.external_contact = formData.external_contact;
                payload.external_mail = formData.external_mail;
                payload.external_reason = formData.external_reason;

            } else {
                payload.employee = formData.employee;
            }
            try {
                let res = await axios.put(
                    `${BASE_URL}/wfm/stationary-employee-details/${i.id}/`,
                    payload,
                );

                if (res.status === 200) {
                    await getEmployeeItemsList();
                    setShow(false)

                }
            } catch (err) {
                handleErrorToast(err, loadingToastId)

            } finally {
                toast.dismiss(loadingToastId);
            }
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
            stat_inventory_details: i.stat_inventory_details.id,
        });
        if (value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }

    };


    return (
        <>
            <button className="model-edit-button-ml" onClick={handleShow}>
                <UpdatePencil />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">

                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <h6 className="task-Tab-heading   font-weight500    font-size-heading">Update Issued Item for {i.employee} </h6>

                            <form>

                                <div className="flex-column form-group-selectt">
                                    <label htmlFor="stat_inventory_details" className="form-labels  font-weight500    font-size-subheading">
                                        Item<span className="required">*</span>
                                    </label>
                                    <br />
                                    <select
                                        disabled
                                        id="stat_inventory_details"
                                        name="stat_inventory_details"
                                        value={formData.stat_inventory_details.id}
                                        onChange={handleInputChange}
                                        className={`form-input form-group-selection ${errors.stat_inventory_details ? "error" : inputState.stat_inventory_details ? "success" : ""
                                            }`}
                                    >
                                        <option value="">Select Item</option>
                                        {stockItemList.map((i) => (<>
                                            <option value={i.id}>{i.item_name} - (Stock : {formattedDateLong(i.purchase_date)})</option>
                                        </>))
                                        }
                                    </select>
                                    <div>
                                        {errors.stat_inventory_details && (
                                            <span className="error-message font-size-text ">{FormatKey(errors.stat_inventory_details)}</span>
                                        )}
                                    </div>
                                </div>

                                <div className="flex-column">
                                    <label htmlFor="quantity" className="form-labels  font-weight500    font-size-subheading">
                                        Quantity<span className="required">*</span>
                                    </label>
                                    <input
                                        type="number"
                                        min={0}
                                        id="quantity"
                                        name="quantity"
                                        onChange={handleInputChange}
                                        value={formData.quantity}
                                        className={`text-capitalize form-input ${errors.quantity ? "error" : inputState.quantity ? "success" : ""
                                            }`}
                                    />
                                    {errors.quantity && <span className="error-message font-size-text ">{FormatKey(errors.quantity)}</span>}
                                </div>

                                <div className="flex-column">
                                    <label htmlFor="recevied_date" className="form-labels  font-weight500    font-size-subheading">
                                        Issue Date<span className="required">*</span>
                                    </label>
                                    <input
                                        type="date"
                                        id="recevied_date"
                                        name="recevied_date"
                                        onChange={handleInputChange}
                                        value={formData.recevied_date}
                                        className={`form-input ${errors.recevied_date ? "error" : inputState.recevied_date ? "success" : ""
                                            }`}
                                    />
                                    {errors.recevied_date && <span className="error-message font-size-text ">{FormatKey(errors.recevied_date)}</span>}
                                </div>
                                {i?.employee === null && (
                                    <>
                                        <div className="flex-column">
                                            <label htmlFor="external_person_name" className="form-labels font-weight500 font-size-subheading">
                                                Name:<span className="required">*</span>
                                            </label>
                                            <input
                                                id="external_person_name"
                                                type="text"
                                                name="external_person_name"
                                                maxLength={150}
                                                placeholder="Name"
                                                onChange={handleInputChange}
                                                value={formData.external_person_name}
                                                className={`form-input ${errors.external_person_name ? "error" : inputState.external_person_name ? "success" : ""
                                                    }`}
                                            />
                                            {errors.external_person_name && (
                                                <span className="error-message font-size-text ">{FormatKey(errors.external_person_name)}</span>
                                            )}
                                        </div>
                                        <div className="flex-column">
                                            <label htmlFor="external_contact" className="form-labels font-weight500 font-size-subheading">
                                                Contact:<span className="required">*</span>
                                            </label>
                                            <input
                                                id="external_contact"
                                                type="text"
                                                name="external_contact"
                                                placeholder="Contact No"
                                                onChange={handleInputChange}
                                                value={formData.external_contact}
                                                className={`form-input ${errors.external_contact ? "error" : inputState.external_contact ? "success" : ""
                                                    }`}
                                            />
                                            {errors.external_contact && (
                                                <span className="error-message font-size-text ">{FormatKey(errors.external_contact)}</span>
                                            )}
                                        </div>
                                        <div className="flex-column">
                                            <label htmlFor="external_mail" className="form-labels font-weight500 font-size-subheading">
                                                Mail:<span className="required">*</span>
                                            </label>
                                            <input
                                                id="external_mail"
                                                type="text"
                                                name="external_mail"
                                                placeholder="Contact Mail"
                                                onChange={handleInputChange}
                                                value={formData.external_mail}
                                                className={`form-input ${errors.external_mail ? "error" : inputState.external_mail ? "success" : ""
                                                    }`}
                                            />
                                            {errors.external_mail && (
                                                <span className="error-message font-size-text ">{FormatKey(errors.external_mail)}</span>
                                            )}
                                        </div>
                                        <div className="flex-column">
                                            <label className="form-labels font-weight500 font-size-subheading">
                                                Reason:<span className="required">*</span>
                                            </label>
                                            <textarea
                                                name="external_reason"
                                                placeholder="Your reason (minimum 10 characters)"
                                                className="form-input-textarea"
                                                value={formData.external_reason}
                                                onChange={handleInputChange}
                                                rows="3"
                                            />
                                        </div>
                                    </>
                                )}
                            </form>
                            <div className="button-models">
                                <button className="model-button model-button-cancel font-weight500" onClick={handleClose}>
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                                    onClick={handleSubmit}
                                >
                                    Update
                                </button>
                            </div>
                        </div>
                        <p className="error-message font-size-text">
                            {isSubmitted && Object.keys(errors).length > 0 && (
                                Object.keys(errors).length > 5 ? (
                                    <h5 className="text-center">Please fill all mandatory fields!</h5>
                                ) : (
                                    <h6 className="text-center">
                                        {Object.keys(errors)
                                            .map((field) =>
                                                field
                                                    .replace(/_/g, ' ')
                                                    .replace(/\b\w/g, (char) => char.toUpperCase())
                                            )
                                            .join(', ') + ' are required!'}
                                    </h6>
                                )
                            )}
                        </p>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    );
};

const DeleteEmployeeStationary = ({ i, getEmployeeItemsList }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
        try {
            let res = await axios.delete(
                `${BASE_URL}/wfm/stationary-employee-details/${i.id}/`
            );

            if (res.status === 200) {
                await getEmployeeItemsList();
                setShow(false);
            } else {
                alert(res);
            }
        } catch (err) {

            handleErrorToast(err, loadingToastId)
        } finally {
            toast.dismiss(loadingToastId);
        }
    };
    return (
        <>
            <button className="model-delete-button" onClick={handleShow}>
                <DeleteDustbin />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Header closeButton>
                    <Modal.Title>Delete {i.employee}'s Issue data of {i.recevied_date}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are You Sure You Want to delete issue data of item : {i.stat_inventory_details.item_name}
                        <div className="button-models">
                            <button className="model-button model-button-cancel font-weight500" onClick={handleClose}>
                                Cancel
                            </button>
                            <button
                                onClick={handleFormSubmitDelete}
                                className="model-button   font-weight500    model-button-delete"
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    );
};

export {
    AddStationaryItem,
    UpdateStationaryItem,
    DeleteStationaryItem,
    AddItemToStock,
    UpdateItemInStock,
    DeleteItemFromStock,
    GiveEmployeeStationary,
    UpdateEmployeeStationary,
    DeleteEmployeeStationary
};
